import React from 'react'

interface PillProps {
  children: React.ReactNode
  variant?: 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'neutral'
  size?: 'sm' | 'md' | 'lg'
  className?: string
  style?: React.CSSProperties
  onClick?: () => void
  clickable?: boolean
}

export default function Pill({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  style,
  onClick,
  clickable = false
}: PillProps) {
  const baseClasses = 'inline-flex items-center justify-center font-medium rounded-full transition-colors'
  const clickableClasses = clickable || onClick ? 'cursor-pointer hover:scale-105 active:scale-95' : ''

  const variantClasses = {
    primary: 'text-primary bg-primary/10 hover:bg-primary/20',
    secondary: 'text-ocean-blue bg-ocean-blue/10 hover:bg-ocean-blue/20',
    success: 'text-green-800 bg-green-100 hover:bg-green-200',
    warning: 'text-yellow-800 bg-yellow-100 hover:bg-yellow-200',
    error: 'text-red-800 bg-red-100 hover:bg-red-200',
    neutral: 'text-slate-800 bg-slate-100 hover:bg-slate-200'
  }

  const sizeClasses = {
    sm: 'px-2 py-1 text-xs',
    md: 'px-3 py-1 text-sm',
    lg: 'px-4 py-2 text-base'
  }

  const classes = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${clickableClasses} ${className}`

  const Component = (clickable || onClick) ? 'button' : 'span'

  return (
    <Component className={classes} style={style} onClick={onClick}>
      {children}
    </Component>
  )
}
